<template>
    <page>
      <div>
        <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs6>
                    <cal-picker v-model="reportForm.expDateFrom" :label="labels.expDateFrom" v-validate="'required'" :data-vv-as="labels.expDateFrom" data-vv-name="expDateFrom" :error-messages="errors.collect('expDateFrom')"></cal-picker>
                  </v-flex>
                  <v-flex xs6>
                    <cal-picker v-model="reportForm.expDateTo" :label="labels.expDateTo" v-validate="'required'" :data-vv-as="labels.expDateTo" data-vv-name="expDateTo" :error-messages="errors.collect('expDateTo')"></cal-picker>
                  </v-flex>
                  <!-- Branch -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')"
                    :data-vv-as="labels.branch" data-vv-name="branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly
                    v-validate="'required'"></v-text-field>
                  </v-flex>
                  <!-- Department -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.dept" :label="labels.dept" :error-messages="errors.collect('dept')"
                    :data-vv-as="labels.dept" data-vv-name="dept" append-icon="mdi-magnify" @click:append="getHelpList('dept')" readonly
                    v-validate="'required'"></v-text-field>
                  </v-flex>
                  <!-- Direct/RI -->
                  <v-flex xs12 sm6>
                    <v-select v-model="reportForm.dri" :items="driList" :label="labels.dri" item-text="label" item-value="value" :data-vv-as="labels.dri" v-validate="'required'"
                                            data-vv-name="reportForm.dri" />
                    </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
    </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
        <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-checkbox color="primary" :label="labels.generateMotor" v-model="reportForm.hasMotor"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.polTypeMotor" :label="labels.polTypeMotor" :error-messages="errors.collect('polTypeMotor')"
                    :data-vv-as="labels.polTypeMotor" data-vv-name="polTypeMotor" append-icon="mdi-magnify" @click:append="getHelpList('moPolType')" readonly
                    v-validate="{ required: requiredIfGenerateMotor }"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.excludeBillAcctMotor" :label="labels.excludeBillAcctMotor" :error-messages="errors.collect('excludeBillAcctMotor')"
                    :data-vv-as="labels.excludeBillAcctMotor" data-vv-name="excludeBillAcctMotor" append-icon="mdi-magnify" @click:append="getHelpList('moBillAcct')" readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
    </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
        <v-expansion-panels v-model="panel3" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-checkbox color="primary" :label="labels.generateCommercial" v-model="reportForm.hasCommercial"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.polTypeCommercial" :label="labels.polTypeCommercial" :error-messages="errors.collect('polTypeCommercial')"
                    :data-vv-as="labels.polTypeCommercial" data-vv-name="polTypeCommercial" append-icon="mdi-magnify" @click:append="getHelpList('coPolType')" readonly
                    v-validate="{ required: requiredIfGenerateCommercial }"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.excludeBillAcctCommercial" :label="labels.excludeBillAcctCommercial" :error-messages="errors.collect('excludeBillAcctCommercial')"
                    :data-vv-as="labels.excludeBillAcctCommercial" data-vv-name="excludeBillAcctCommercial" append-icon="mdi-magnify" @click:append="getHelpList('coBillAcct')" readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
    </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
        <v-expansion-panels v-model="panel4" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-checkbox color="primary" :label="labels.generatePersonal" v-model="reportForm.hasPersonal"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.polTypePersonal" :label="labels.polTypePersonal" :error-messages="errors.collect('polTypePersonal')"
                    :data-vv-as="labels.polTypePersonal" data-vv-name="polTypePersonal" append-icon="mdi-magnify" @click:append="getHelpList('plPolType')" readonly
                    v-validate="{ required: requiredIfGeneratePersonal }"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.excludeBillAcctPersonal" :label="labels.excludeBillAcctPersonal" :error-messages="errors.collect('excludeBillAcctPersonal')"
                    :data-vv-as="labels.excludeBillAcctPersonal" data-vv-name="excludeBillAcctPersonal" append-icon="mdi-magnify" @click:append="getHelpList('plBillAcct')" readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
    </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
        <v-form>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox
                  :label="labels.pbPrtParam"
                  v-model="reportForm.pbPrtParam"
                  :error-messages="errors.collect('pbPrtParam')"
                  data-vv-name="pbPrtParam"
                  :data-vv-as="labels.pbPrtParam"
                />
              </v-flex>
              <v-flex xs12>
                <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
      <v-dialog v-model="branchHelpList" width="900px" persistent>
          <multi-branch-help-list :brn="reportForm.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
      </v-dialog>
      <v-dialog v-model="deptHelpList" width="900px" persistent>
          <multi-dept-help-list :dept="reportForm.dept" @close="doClose" @doAssign="doAssignDept($event)" />
      </v-dialog>
      <v-dialog v-model="motorPolTypeHelpList" width="900px" persistent>
          <pol-type-help-list :polType="'MO'" @close="doClose" @doAssign="doAssignPolTypeMotor($event)"></pol-type-help-list>
      </v-dialog>
      <v-dialog v-model="commercialPolTypeHelpList" width="900px" persistent>
          <pol-type-help-list :polType="'CO'" @close="doClose" @doAssign="doAssignPolTypeCommercial($event)"></pol-type-help-list>
      </v-dialog>
      <v-dialog v-model="personalPolTypeHelpList" width="900px" persistent>
          <pol-type-help-list :polType="'PL'" @close="doClose" @doAssign="doAssignPolTypePersonal($event)"></pol-type-help-list>
      </v-dialog>
      <v-dialog v-model="motorBillAcctHelpList" width="900px" persistent>
          <multi-intermediary-help-list :intr="reportForm.excludeBillAcctMotor" @close="doClose" @doAssign="doAssignBillAcctMotor($event)"></multi-intermediary-help-list>
      </v-dialog>
      <v-dialog v-model="commercialBillAcctHelpList" width="900px" persistent>
        <multi-intermediary-help-list  @close="doClose" :intr="reportForm.excludeBillAcctCommercial" @doAssign="doAssignBillAcctCommercial($event)"></multi-intermediary-help-list>
      </v-dialog>
      <v-dialog v-model="personalBillAcctHelpList" width="900px" persistent>
        <multi-intermediary-help-list @close="doClose" :intr="reportForm.excludeBillAcctPersonal" @doAssign="doAssignBillAcctPersonal($event)"></multi-intermediary-help-list>
      </v-dialog>
    </page>
  </template>

<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import PolTypeHelpList from './helplist/PolTypeHelpList.vue'
import MultiIntermediaryHelpList from './helplist/MultiIntermediaryHelpList.vue'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    MessageMixin
  ],
  created() {
    this.doInit()
  },
  components: {
    MultiBranchHelpList,
    MultiDeptHelpList,
    PolTypeHelpList,
    MultiIntermediaryHelpList
  },
  data() {
    return {
      labels: {
        expDateFrom: 'Expiry Date From',
        expDateTo: 'Expiry Date To',
        branch: 'Branch',
        dept: 'Dept',
        dri: 'Direct/RI',
        polType: 'Policy Type',
        excludeBillAcct: 'Exclude Billing Account',
        generateMotor: 'Generate Motor Line',
        generateCommercial: 'Generate Commercial Line',
        generatePersonal: 'Generate Personal Line',
        export: 'Export To',
        polTypeMotor: 'Policy Type',
        excludeBillAcctMotor: 'Exclude Billing Account',
        polTypeCommercial: 'Policy Type',
        excludeBillAcctCommercial: 'Exclude Billing Account',
        polTypePersonal: 'Policy Type',
        excludeBillAcctPersonal: 'Exclude Billing Account',
        pbPrtParam: 'Print Runtime Parameters'
      },
      reportForm: {
        expDateFrom: undefined,
        expDateTo: undefined,
        branch: 'All',
        dept: 'All',
        dri: 'B',
        hasMotor: false,
        hasCommercial: false,
        hasPersonal: false,
        polTypeMotor: undefined,
        polTypeCommercial: undefined,
        polTypePersonal: undefined,
        excludeBillAcctMotor: undefined,
        excludeBillAcctCommercial: undefined,
        excludeBillAcctPersonal: undefined,
        format: undefined,
        pbPrtParam: true
      },
      driList: [
        { label: 'D - Direct', value: 'D' },
        { label: 'R - Reinsurance', value: 'R' },
        { label: 'B - Both', value: 'B' }
      ],
      panel1: [0],
      panel2: [],
      panel3: [],
      panel4: [],
      panel5: [],
      branchHelpList: false,
      deptHelpList: false,
      motorPolTypeHelpList: false,
      commercialPolTypeHelpList: false,
      personalPolTypeHelpList: false,
      motorBillAcctHelpList: false,
      commercialBillAcctHelpList: false,
      personalBillAcctHelpList: false,
      supportedFormat: [],
      loading: false
    }
  },
  computed: {
    requiredIfGenerateMotor() {
      return this.reportForm.hasMotor
    },
    requiredIfGenerateCommercial() {
      return this.reportForm.hasCommercial
    },
    requiredIfGeneratePersonal() {
      return this.reportForm.hasPersonal
    },
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initRenewalListing
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
          const resultData = await this.$http.get(this.menu.initData)
          if (resultData.data) {
            const { data } = resultData
            if (data) {
              this.reportForm.polTypeMotor = data.data.mtr
              this.reportForm.polTypeCommercial = data.data.comm
              this.reportForm.polTypePersonal = data.data.per
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      if (!this.reportForm.hasMotor && !this.reportForm.hasCommercial && !this.reportForm.hasPersonal) {
        this.$toast.error('Please generate at least one report!')
        return
      }
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu.export
      if (apiUrl) {
        try {
          this.loading = true
          if (this.reportForm.excludeBillAcctMotor === undefined) {
            this.reportForm.excludeBillAcctMotor = ''
          }
          if (this.reportForm.excludeBillAcctCommercial === undefined) {
            this.reportForm.excludeBillAcctCommercial = ''
          }
          if (this.reportForm.excludeBillAcctPersonal === undefined) {
            this.reportForm.excludeBillAcctPersonal = ''
          }
          await this.$http.post(apiUrl, this.reportForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [processExport]')
      }
      this.loading = false
    },
    getHelpList(type) {
      switch (type) {
        case 'branch':
          this.branchHelpList = true
          break
        case 'dept':
          this.deptHelpList = true
          break
        case 'moPolType':
          this.motorPolTypeHelpList = true
          break
        case 'coPolType':
          this.commercialPolTypeHelpList = true
          break
        case 'plPolType':
          this.personalPolTypeHelpList = true
          break
        case 'moBillAcct':
          this.motorBillAcctHelpList = true
          break
        case 'coBillAcct':
          this.commercialBillAcctHelpList = true
          break
        case 'plBillAcct':
          this.personalBillAcctHelpList = true
          break
      }
    },
    async doClose() {
      this.branchHelpList = false
      this.deptHelpList = false
      this.motorPolTypeHelpList = false
      this.commercialPolTypeHelpList = false
      this.personalPolTypeHelpList = false
      this.motorBillAcctHelpList = false
      this.commercialBillAcctHelpList = false
      this.personalBillAcctHelpList = false
    },
    async doAssignBranch(obj) {
      this.reportForm.branch = []
      this.reportForm.branch = obj.finalSelectedItems.toString()
    },
    async doAssignDept(Obj) {
      this.reportForm.dept = []
      this.reportForm.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignPolTypeMotor(Obj) {
      this.reportForm.polTypeMotor = []
      this.reportForm.polTypeMotor = Obj.finalSelectedItems.toString()
    },
    async doAssignPolTypeCommercial(Obj) {
      this.reportForm.polTypeCommercial = []
      this.reportForm.polTypeCommercial = Obj.finalSelectedItems.toString()
    },
    async doAssignPolTypePersonal(Obj) {
      this.reportForm.polTypePersonal = []
      this.reportForm.polTypePersonal = Obj.finalSelectedItems.toString()
    },
    async doAssignBillAcctMotor(Obj) {
      this.reportForm.excludeBillAcctMotor = []
      this.reportForm.excludeBillAcctMotor = Obj.finalSelectedItems.toString()
      if (this.reportForm.excludeBillAcctMotor === 'All') {
        this.reportForm.excludeBillAcctMotor = undefined
      }
    },
    async doAssignBillAcctCommercial(Obj) {
      this.reportForm.excludeBillAcctCommercial = []
      this.reportForm.excludeBillAcctCommercial = Obj.finalSelectedItems.toString()
      if (this.reportForm.excludeBillAcctCommercial === 'All') {
        this.reportForm.excludeBillAcctCommercial = undefined
      }
    },
    async doAssignBillAcctPersonal(Obj) {
      this.reportForm.excludeBillAcctPersonal = []
      this.reportForm.excludeBillAcctPersonal = Obj.finalSelectedItems.toString()
      if (this.reportForm.excludeBillAcctPersonal === 'All') {
        this.reportForm.excludeBillAcctPersonal = undefined
      }
    }
  }
}
</script>
